import * as rotationTrainingUrl from 'src/helpers/url_helper';
import { apiSlice } from 'src/rtk/api/apiSlice';

export const rotationTrainingApi = apiSlice
  .enhanceEndpoints({ addTagTypes: ['ROTATION_TRAINING'] })
  .injectEndpoints({
    endpoints: (builder) => ({
        getRotationTraining: builder.query<any, void>({
            query: () => ({
                method: 'GET',
                url: `${rotationTrainingUrl.GET_ROTATION_TRAINING}`,
            }),
            providesTags: ['ROTATION_TRAINING'],
        }),

      createRotationTraining: builder.mutation<
        APIResponse<any>,
        any
      >({
        query: (data: any) => ({
          url: `${rotationTrainingUrl.CREATE_ROTATION_TRAINING}`,
          method: 'POST',
          body: data,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }),
        invalidatesTags: ['ROTATION_TRAINING'],
      }),

      updateRotationTraining: builder.mutation<
        APIResponse<any>,
        any
      >({
        query: ({ id, data }) => ({
          url: `${rotationTrainingUrl.UPDATE_ROTATION_TRAINING}/${id}`,
          method: 'POST',
          body: data,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }),
        invalidatesTags: ['ROTATION_TRAINING'],
      }),

      deleteRotationTraining: builder.mutation<APIResponse<any>, string>({
        query: (id: string) => ({
          method: 'DELETE',
          url: `${rotationTrainingUrl.DELETE_ROTATION_TRAINING}/${id}`,
        }),
        invalidatesTags: ['ROTATION_TRAINING'],
      }),
    }),
  });

export const {
  useGetRotationTrainingQuery,
  useCreateRotationTrainingMutation,
  useUpdateRotationTrainingMutation,
  useDeleteRotationTrainingMutation,
} = rotationTrainingApi;